// extracted by mini-css-extract-plugin
export default {"header":"Header_header__OKWO7","switch":"Header_switch__yAhpA","headerRight":"Header_headerRight__CSwO3","input":"Header_input__lIOyC"};